import { useNavigate } from 'react-router-dom'
export function useNavigateBack() {
  const navigate = useNavigate()

  return () => {
    if (window.history.length <= 1) {
      window.location.href = window.location.origin
    } else {
      navigate(-1)
    }
  }
}
